import { toast } from "@assetwatch/ui";
import { useMutation } from "@tanstack/react-query";
import {
  isIntakeAiUnavailableError,
  sendWorkRequestIntakeMessage,
} from "../clients/workIntakeClient";
import { useWorkScope } from "../components/WorkScopeProvider";
import type { WorkRequestIntakeState } from "../types/workRequest";

type SendIntakeMessageInput = {
  state: WorkRequestIntakeState;
  userMessage: string;
};

export function useWorkRequestIntakeMutation() {
  const { selectedCustomer, selectedFacility } = useWorkScope();

  return useMutation({
    mutationFn: async ({ state, userMessage }: SendIntakeMessageInput) => {
      if (!selectedCustomer || !selectedFacility) {
        throw new Error("A customer and facility must be selected.");
      }

      return sendWorkRequestIntakeMessage({
        customerId: selectedCustomer.id,
        facilityId: selectedFacility.id,
        state,
        userMessage,
      });
    },
    onError: (error) => {
      // An AI-unavailable failure is not an error toast: the side sheet moves
      // the requester to the form and explains it there.
      if (isIntakeAiUnavailableError(error)) return;
      toast.error("Unable to process the Work Request. Try again.", {
        icon: true,
      });
    },
  });
}
